<script setup lang="ts">
import SSFooter from '../components/footer/SSFooter.vue'
import SSHeader from '../components/SSHeader.vue'
</script>

<template>
  <SSHeader />
  <main class="ss-app__main" data-testid="ss-app-main-page-layout">
    <slot name="main-content" />
  </main>
  <SSFooter />
</template>
